/**
 * Download CSV data as a file
 */
export const downloadCSV = (csvData: string, filename = "safer-data.csv") => {
  if (csvData) {
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
};

/**
 * Get the number of columns in CSV data
 */
export const getCsvColumnCount = (csvPreview: string): number => {
  const lines = csvPreview.split("\n").filter((line) => line.trim());
  if (lines.length === 0) return 0;
  const headers = lines[0].split(",");
  return headers.length;
};
